import ComposeLinkViewState from '../store/schema/ComposeLinkViewState';
import getStore from '../store/store';

export default function getComposeLinkViewState(linkId: string): ComposeLinkViewState {
    const store = getStore();
    return store.composeLinks.get(linkId);
}
